import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xmneagxgkjivcfxtyzke.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhtbmVhZ3hna2ppdmNmeHR5emtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4OTgyOTAsImV4cCI6MjA5MjQ3NDI5MH0.wILgr2I6l02M8zwZzoagRfFiHCSMve-Pkk8-70TaLPU';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);